module.exports = __webpack_public_path__ + "static/img/3-2-create-aftersale-return.17b92b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-2-create-aftersale-return.png
// module id = 1323
// module chunks = 0